
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobile-app-with-bluetooth",
      function () {
        return require("private-next-pages/mobile-app-with-bluetooth.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobile-app-with-bluetooth"])
      });
    }
  